module.exports = __webpack_public_path__ + "media/images/about/history/president-2-8d1561a766fd7dc8f994e5ec452d3e1f.png";